export default __webpack_public_path__ + "static/manage-access-dark-9cdf84dae6d9252137e5b1e6674ca526.png";